<div class="grid">
    <div class="col-12" *ngIf="!mS.userCellePreConf()">

        <p-meterGroup [value]="kpi" labelPosition="start">
            <ng-template pTemplate="label">
                <div class="flex flex-wrap gap-3">
                    <ng-container *ngFor="let meterItem of kpi; let index = index">
                        <p-card class="flex-1">
                            <div class="flex justify-content-between gap-5">
                                <div class="flex flex-column gap-1">
                                    <h3 >{{ meterItem.label }}</h3>
                                    <span *ngIf="meterItem.label!='Acquisito'" class="font-bold text-lg">{{ meterItem.value }}% </span>
                                    <span *ngIf="meterItem.label=='Acquisito'" class="font-bold text-lg">{{ meterItem.valueTotPerc }}%</span>
                                    <span class="font-bold text-lg">{{ meterItem.valueTot | currency:'EUR':'symbol' }}</span>
                                </div>
                                <span class="w-2rem h-2rem border-circle inline-flex justify-content-center align-items-center text-center" 
                                    [style]="{ 'background-color': meterItem.color1, color: '#ffffff' }">
                                    <i [class]="meterItem.icon"></i>
                                </span>
                            </div>
                        </p-card>
                    </ng-container>
                </div>
            </ng-template>
            
        </p-meterGroup>
    </div>
   

    <div class="col-12 lg:col-8">

        <div class="card">
            <div class="flex flex-column md:flex-row md:align-items-start md:justify-content-between mb-3">
                <div class="text-900 text-xl font-semibold mb-3 md:mb-0">{{lang.el('Ultimi preventivi')}}</div>
            </div>
            <p-table #maintable 
                [value]="opportunitiesData" 
				dataKey="id" 
				[paginator]="false" 
				[rows]="20" 
				[tableStyle]="{ 'min-width': '60rem' }" >
				
				<ng-template pTemplate="header">
					<tr>
                        <th></th>
						<th pSortableColumn="numero">{{lang.el('Numero')}}<p-sortIcon field="numero" /></th>
						<th pSortableColumn="account_name">{{lang.el('Cliente')}}<p-sortIcon field="account_name" /></th>
						<th pSortableColumn="name">{{lang.el('Descrizione')}}<p-sortIcon field="name" /></th>
						<th pSortableColumn="assigned_name">{{lang.el('Assegnato a')}} <p-sortIcon field="assigned_name" /></th>
						<th pSortableColumn="status">{{lang.el('Stato')}} <p-sortIcon field="status" /></th>
						<th pSortableColumn="exp_closing_date">{{lang.el('Data')}} <p-sortIcon field="exp_closing_date" /></th>
						<th pSortableColumn="amount">{{lang.el('Importo')}} <p-sortIcon field="amount" /></th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-opp>
					<tr>
                        <td>
							<button pButton pRipple icon="pi pi-pencil" 
							class="p-button-rounded p-button-text" (click)="editPrev(opp)"></button>
						</td>
						<td>{{ opp.numero }}</td>
						<td>{{ opp.account_name }}</td>
						<td>{{ opp.name }}</td>
						<td>{{ opp.assigned_to_name }}</td>
                        <td>{{lang.el(opp.status)}}</td>
						<td>{{ opp.exp_closing_date }}</td>
						<td>{{ opp.amount | currency : 'EUR' }}</td>
					</tr>
				</ng-template>
			</p-table>


            
        </div>
    </div>
    <div class="col-12 lg:col-4">
        <div class="card h-full">
            <div class="text-900 text-xl font-semibold mb-3">{{lang.el('Inizia subito')}}</div>
            <div class="card m-3 homecard">
                <div class="card-body">
                    <div class="grid" (click)="goto('nuovopreventivo')">
                        <div class="col-2">
                            <i class="pi pi-check"  style="font-size: 2rem"></i>
                        </div>
                        <div class="col-10">
                            <h4>{{lang.el('Fai un nuovo preventivo')}}</h4>
                            <p>{{lang.el('imposta un preventivo e configura le celle associate')}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card m-3 homecard">
                <div class="card-body">
                    <div class="grid" (click)="goto('nuovocliente')">
                        <div class="col-2">
                            <i class="pi pi-users"  style="font-size: 2rem"></i>
                        </div>
                        <div class="col-10">
                            <h4>{{lang.el('Inserisci un nuovo cliente')}}</h4>
                            <p>{{lang.el('inserisci il codice e la ragione sociale')}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card m-3 homecard">
                <div class="card-body">
                    <div class="grid" (click)="goto('elencopreventivi')">
                        <div class="col-2">
                            <i class="pi pi-money-bill"  style="font-size: 2rem"></i>
                        </div>
                        <div class="col-10">
                            <h4>{{lang.el('Consulta l\'elenco preventivi')}}</h4>
                            <p>{{lang.el('ricerca modifica esporta preventivi')}} </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card m-3 homecard" >
                <div class="card-body">
                    <div class="grid" (click)="goto('tutorial')">
                        <div class="col-2">
                            <i class="pi pi-video"  style="font-size: 2rem"></i>
                        </div>
                        <div class="col-10">
                            <h4>{{lang.el('Guarda la videoguida')}}</h4>
                            <p>{{lang.el('consulta il video tutorial')}} </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-dialog header="{{lang.el('Video tutorial')}}" [(visible)]="showTutorial" 
[modal]="true" 
[style]="{ width: '35vw' }" 
[draggable]="false" [resizable]="false">
    <div class="grid" *ngIf="globalService.getUser().organization=='DAGARD'">
        <div class="col-1 ml-3">
            <i class="pi pi-video"></i>
        </div>
        <div class="col-10">
            <a href="./assets/video/Creer_un_offre.mp4" target="_blank"> <b>{{lang.el("Creare un'offerta")}}</b></a>
        </div>
        <div class="col-1 ml-3">
            <i class="pi pi-video"></i>
        </div>
        <div class="col-10">
            <a href="./assets/video/Creer_une_nouvelle_CF.mp4" target="_blank"> <b>{{lang.el("Crea un nuovo CF")}}</b></a>
        </div>
        <div class="col-1 ml-3">
            <i class="pi pi-video"></i>
        </div>
        <div class="col-10">
            <a href="./assets/video/Imprimer_un_dessin.mp4" target="_blank"> <b>{{lang.el("Stampa un disegno")}}</b></a>
        </div>
    </div>
    <div class="grid" *ngIf="globalService.getUser().organization=='MISA'">
        <div class="col-1 ml-3">
            <i class="pi pi-video"></i>
        </div>
        <div class="col-10">
            <a href="./assets/video/modificapassword.mp4" target="_blank"> <b>{{lang.el("Cambio password")}}</b></a>
        </div>
        <div class="col-1 ml-3">
         </div>
        <div class="col-10">
         </div>
        <div class="col-1 ml-3">
        </div>
        <div class="col-10">
         </div>
    </div>
  <p-footer>
    <button pButton pRipple class="p-button-danger flex-1 p-button-outlined" 
                (click)="showTutorial=false"
                label="{{lang.el('Chiudi')}}"></button>
  </p-footer>
</p-dialog>